import React from 'react';
import { connect } from 'react-redux';
import EmptyReviews from 'src/components/Reviews/EmptyReviews';

import {
  getHotelName,
  getHotelLink,
  getInitialPrice,
} from '../../store/selectors/hotel';
import { isRating } from '../../store/selectors/rating';
import { getHasReviewsSection } from '../../store/selectors/view';
import { ReviewsDesktop } from '../../components/Reviews';

const ReviewsComp = ({
  hasReviewsSection,
  isRatingExists,
  hotelName,
  hotelLink,
  price,
}) =>
  hasReviewsSection ? (
    <ReviewsDesktop
      isRatingExists={isRatingExists}
      hotelLink={hotelLink}
      hotelName={hotelName}
      price={price}
    />
  ) : (
    <EmptyReviews />
  );

const mapStateToProps = (state) => ({
  isRatingExists: isRating(state),
  hasReviewsSection: getHasReviewsSection(state),
  hotelName: getHotelName(state),
  hotelLink: getHotelLink(state),
  price: getInitialPrice(state),
});

export default connect(mapStateToProps)(React.memo(ReviewsComp));
